export function calculatePercentagePosition(
  value: number,
  min: number,
  max: number
) {
  return ((value - min) / (max - min)) * 100;
}

export function calculateSubrangePercentage(
  minSubrange: number,
  maxSubrange: number,
  minRange: number,
  maxRange: number
) {
  const startPercentage = calculatePercentagePosition(
    minSubrange,
    minRange,
    maxRange
  );
  const endPercentage = calculatePercentagePosition(
    maxSubrange,
    minRange,
    maxRange
  );
  return endPercentage - startPercentage;
}

export const getPosition = (
  score: number,
  minScore: number,
  maxScore: number
) => `${Math.round(((score - minScore) / (maxScore - minScore)) * 100)}%`;
